import { defineMessages } from "react-intl";

export const messages = defineMessages({
  copyAddress: {
    defaultMessage: "Copy address",
    id: "6uyiWX",
    description: "button label, copies the postal address to the clipboard",
  },
});
